import { render, staticRenderFns } from "./preferential-merchant-registration.vue?vue&type=template&id=0b643c4e"
import script from "./preferential-merchant-registration.vue?vue&type=script&lang=js"
export * from "./preferential-merchant-registration.vue?vue&type=script&lang=js"
import style0 from "./preferential-merchant-registration.vue?vue&type=style&index=0&id=0b643c4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports